import {
  REMOVE_FROM_CART_EVENT_NAME,
  REMOVE_FROM_CART_EVENT_DETAIL,
  REMOVE_FROM_CART_DEFAULT_EVENT_TYPE,
  PRIMARY_CATEGORY,
} from '~~/constants/googleTagManager';
import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';
import type { TagProduct } from '~~/types/integrations/tagManager/TagProduct';

export const buildRemoveFromCartTags = (
  productTags: TagProduct,
  textDisplayed: string = '',
  triggeredIn: EventSourceLocation = undefined,
) => ({
  event: REMOVE_FROM_CART_EVENT_NAME,
  eventInfo: {
    detail: REMOVE_FROM_CART_EVENT_DETAIL,
    text_displayed: textDisplayed,
    triggered_in: triggeredIn,
  },
  category: {
    event_type: REMOVE_FROM_CART_DEFAULT_EVENT_TYPE,
    primary_category: PRIMARY_CATEGORY,
  },
  ecommerce: { items: [productTags] },
});
